module.exports = __webpack_public_path__ + "static/media/bråkete.bb19afcd.m4a";